<div class="visitortype-related-image" >
    <sc-padding>
        <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
            <img src="{{imageUrl}}"/>
        </sc-flex>
    </sc-padding>
</div>